import SearchEngineAdapter from 'Services/Adapters/SearchEngine/SearchEngineAdapter';

export default class ContactAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'contact';
    }

    constructor(data = []) {
        super(data);
        this.key = ContactAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Contact'),
            icon: 'obj-slsy-contact',
            count: 0,
            items: [],
        };
    }

    formatItem(item) {
        return {
            id: item.object.id,
            name: item.first_name + ' ' + item.last_name,
            company: item.companies.length > 0 ? item.companies[0].name : '',
            position: item.position,
            link: `/peoples/${item.object.id}`,
            component: 'search-result-contact',
        };
    }
}
